import { cn } from "@humanex/ui/libs";

interface LogoProps {
  className?: string;
  variant?: "horizontal" | "mark" | "responsive";
}

export function Logo({ className, variant = "responsive" }: LogoProps) {
  return (
    <a
      href="/"
      className={cn("flex items-center justify-center overflow-hidden", className)}
      aria-label="Humanex Asia Homepage"
    >
      {variant === "responsive" ? (
        <>
          <img
            src="/logo-text.png"
            alt="Humanex Asia"
            className="h-full w-full object-contain md:hidden lg:block"
          />
          <img
            src="/logo.png"
            alt="Humanex Asia"
            className="hidden h-full w-full object-contain md:block lg:hidden"
          />
        </>
      ) : (
        <img
          src={variant === "horizontal" ? "/logo-text.png" : "/logo.png"}
          alt="Humanex Asia"
          className="h-full w-full object-contain"
        />
      )}
    </a>
  );
}
